module.exports = __webpack_public_path__ + "static/img/lynzfwcx.6cd3b4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lynzfwcx.jpg
// module id = T69S
// module chunks = 1